// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cMH8R{display:flex;box-sizing:border-box;align-items:center;border-radius:8px}.cMH8R>*+*{margin-left:8px}.cMH8R.Ry6Z8{padding:4px 8px}.cMH8R.qlmJ1{padding:8px}.cMH8R.w2qHh{padding:8px 16px}.cMH8R.NS022{background:transparent}.cMH8R.NU984._6EXjO,.cMH8R.NS022._6EXjO{box-shadow:0 2px 10px rgba(0,0,0,.08);transition:box-shadow .2s}.cMH8R.dEb8g{background:#181716}.cMH8R.dEb8g button{color:#989898}.Q-i8h:first-child{padding-right:8px;border-right:1px solid transparent}.Q-i8h:last-child{padding-left:8px;border-left:1px solid transparent}.NS022 .Q-i8h{border-color:#989898}.dEb8g .Q-i8h{border-color:#2d2d2d}.w2qHh .Q-i8h{margin-left:16px}.w2qHh .Q-i8h:first-child{padding-right:16px}.w2qHh .Q-i8h:last-child{padding-left:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articleActions": "cMH8R",
	"small": "Ry6Z8",
	"thin": "qlmJ1",
	"wide": "w2qHh",
	"light": "NS022",
	"a11y": "NU984",
	"withShadow": "_6EXjO",
	"dark": "dEb8g",
	"close": "Q-i8h"
};
module.exports = ___CSS_LOADER_EXPORT___;
